// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
import {getAuth, GoogleAuthProvider} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAK9SCIiouGX-FS2JH3JkYQR2MniRNRy98",
  authDomain: "taskbackend-a96a3.firebaseapp.com",
  projectId: "taskbackend-a96a3",
  storageBucket: "taskbackend-a96a3.appspot.com",
  messagingSenderId: "667086876598",
  appId: "1:667086876598:web:fc595a704f1a96b8475b17"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
